module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-crop fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('ExitConfirmation', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exitConfirmationDialog),
      expression: "exitConfirmationDialog"
    }],
    attrs: {
      "exitConfirmationDialog": _vm.exitConfirmationDialog,
      "backTo": {
        name: 'ManageField',
        params: {
          field: _vm.field
        }
      }
    },
    on: {
      "update:exitConfirmationDialog": function($event) {
        _vm.exitConfirmationDialog = $event
      },
      "update:exit-confirmation-dialog": function($event) {
        _vm.exitConfirmationDialog = $event
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exitConfirmationDialog),
      expression: "!exitConfirmationDialog"
    }],
    staticClass: "div-center-horizontally"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-layout', {
    staticClass: "header-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "div-center-vertically"
  }, [_c('p', {
    staticClass: "crop-data"
  }, [_vm._v(_vm._s(_vm.$t('AddCrop.cropData')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "div-center-vertically div-right-horizontally"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "close-icon"
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "crop-content-row",
    attrs: {
      "row": ""
    }
  }, [_c('CropEditor', {
    attrs: {
      "cropData": _vm.crop,
      "comesFromAnotherRoute": _vm.comesFromAnotherRoute,
      "comesFromAnotherRouteData": _vm.comesFromAnotherRouteData,
      "isNewCrop": _vm.isNewCrop
    },
    on: {
      "update:cropData": function($event) {
        _vm.crop = $event
      },
      "update:crop-data": function($event) {
        _vm.crop = $event
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fef9a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddCrop.vue
// module id = 1733
// module chunks = 0